import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import FeatureOptionList from '../../features/featureOption/featureOptionList/FeatureOptionList';
import { useSelectedColorFeatures } from '../../../../../hooks/features/useSelectedColorFeatures';
import ICategoryAttributes from '../../../../../model/ICategoryAttributes';
import IExtendedFeaturesList from '../../../../../model/IExtendedFeaturesList';
import { useCheckSelectedFeatures } from '../../../../../hooks/features/useCheckSelectedFeatures';
import { FeatureType } from '../../../../../enum/FeatureType';
import IFeature from '../../../../../model/IFeature';
import FeatureColorName from '../../features/featureColor/featureColorName/FeatureColorName';

export interface ILayoutTwoProps {
  featuresList: IExtendedFeaturesList;
  categoryAttributes?: ICategoryAttributes;
  openAccessoryDetailsModal: (value: boolean, feature: IFeature) => void;
}

const LayoutTwo: FC<ILayoutTwoProps> = ({ featuresList, categoryAttributes, openAccessoryDetailsModal }) => {
  const { handleColorSelection, colorSelectionCode, colorSelectionName } = useSelectedColorFeatures(featuresList);
  const { handleCheckboxChange } = useCheckSelectedFeatures();

  return (
    <Box display="flex" flexDirection="column">
      {categoryAttributes?.displaylabelofselectedoptiononcategory && (
        <FeatureColorName title={colorSelectionName} featureId={colorSelectionCode} />
      )}
      <FeatureOptionList
        featuresList={featuresList}
        onClick={categoryAttributes.selectiontype === FeatureType.multi ? handleCheckboxChange : handleColorSelection}
        categoryAttributes={categoryAttributes}
        openAccessoryDetailsModal={openAccessoryDetailsModal}
      />
    </Box>
  );
};

export default LayoutTwo;
